// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3jfWm","headerTick":"styles_headerTick__Genbx"};